export const linkToUserSettings = () => "/user/settings";

export const linkToLogin = () => "/login";

export function linkToAuth0Callback() {
  return "/auth0/callback";
}
